import { HttpClient, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class MmuApiBaseService {

  get basePath(): string {
    return this._basePath;
  }

  protected _basePath = '/api';

  protected constructor(protected http: HttpClient) { }

  isApiRequest(req: HttpRequest<any>): boolean {
    return req.url.includes(this.basePath);
  }
}
